var render, staticRenderFns
import script from "./ContextMenu.vue?vue&type=script&lang=tsx"
export * from "./ContextMenu.vue?vue&type=script&lang=tsx"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=43813098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43813098",
  null
  
)

export default component.exports